import React, { FC } from "react";
import DocumentTitle from "react-document-title";
import { Col, Grid, Row } from "react-flexbox-grid";
import { RouteComponentProps } from "react-router-dom";

import { StandardLayout } from "layouts";

export interface TermsPageStateProps { }

export interface TermsPageDispatchProps { }

export interface TermsPageOwnProps extends RouteComponentProps<any> { }

export type TermsPageProps = TermsPageDispatchProps & TermsPageOwnProps & TermsPageStateProps;

export const TermsPage: FC<TermsPageProps> = () => {

    const __SUPPORT_EMAIL__: string = window.xaStudioConfig.supportEmail;

    return (
        <DocumentTitle title="XAPP | Terms of Use">
            <StandardLayout>
                <Grid>
                    <Row>
                        <Col xs>
                            <h1>Terms of Service</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h4>Last updated: September 26, 2017</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h5>
                                BY USING THIS WEB PORTAL, YOU, THE USER, (THE “CUSTOMER”) ACKNOWLEDGES READING THESE
                                TERMS OF SERVICE (THE “AGREEMENT”) AND ENTERING INTO A LEGAL, BINDING CONTRACT WITH
                                XAPPMEDIA, INC. (“XAPPMEDIA”).{" "}
                            </h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h3>1. XAPPmedia Services</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <p>
                                An attached Service Order (a description of services and payments) may be
                                incorporated into this Agreement at the time you click through the payment option,
                                and/or upon execution of that particular Service Order. XAPPMEDIA agrees to provide
                                the services described in any attached Service Order(s). Additional XAPPMEDIA
                                services may be incorporated into this Agreement through Service Orders.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h3>2. Terms of Services</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <p>{`XAPPMEDIA and Customer agree to abide by all applicable Terms of Use of Amazon.  (https://developer.amazon.com/public/support/legal/tou). XAPPMEDIA reserves the right, at any time, to create or amend its own terms of service (including this document), which must be complied with.`}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h3>3. Payment</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <p>
                                Customer agrees to pay XAPPMEDIA the amounts specified in any Service Order or
                                detailed in this web application, by credit card, upon making the Order or clicking
                                the appropriate button, and continuing monthly until terminated as provided in this
                                Agreement. Any overdue amount will accrue interest at the greater of the prevailing
                                federal interest rate or the maximum amount permitted by law. Late payments (those
                                over 30 days of submission of an invoice) shall include a 10% late payment fee and
                                bear interest (calculated daily) at the greater of 1% per month or the maximum rate
                                allowable by law.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h3>4. Configuration</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <p>
                                XAPPMEDIA will review the information you provide and configure it within currently
                                existing templates for Customers of the portal.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h3>5. Content Control</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <p>
                                XAPPMEDIA will not edit or make changes to the Content, including but not limited to
                                text, pictures, sound, graphics, video and other data for Customer's voice app
                                (collectively the "Content"). (XAPPMEDIA may provide, at its discretion,
                                recommendations with regard to the Content.) Customer shall be responsible for
                                updating Content through the web portal, which shall be available on a reasonably
                                regular basis.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h3>6. Upload of Content</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <p>
                                XAPPMEDIA is solely responsible for providing the means for Customer’s upload of the
                                Content.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h3>7. Ownership Rights and Licenses</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <p>
                                Customer is the owner of Customer's brand name and logo and all of Customer's
                                content. XAPPMEDIA is the owner of XAPPMEDIA's Platform. Customer grants to
                                XAPPMEDIA, in conjunction with Customer's voice experience only, a nonexclusive,
                                royalty free, worldwide license to reproduce, distribute, publicly display,
                                and digitally perform the content and work product for Customer's voice app,
                                including but not limited to rights to use Customer’s logo and brand name audibly
                                and visually within the voice app and in any backups. Customer and XAPPMEDIA each
                                grant to the other a nonexclusive, nontransferable, royalty free, worldwide license
                                to use the other's domain names, anonymized data from the voice app, trademarks,
                                service marks, trade names, logos, or other commercial designation for purposes of
                                creating content directories or indexes and for marketing and promotional purposes.
                                The licensing rights granted in this paragraph (excepting those for marketing and
                                promotional purposes) will automatically terminate with the termination
                                of XAPPMEDIA's service for Customer. FOR THE AVOIDANCE OF DOUBT, XAPPMEDIA’s
                                PLATFORM IS AND SHALL ALWAYS REMAIN THE PROPERTY OF XAPPMEDIA.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h3>8. Term</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <p>
                                The initial term of this Agreement shall be for thirty (30) days. This Agreement
                                shall automatically renew for successive monthly [thirty (30) day] terms thereafter,
                                until terminated by either party with thirty (30) days’ prior written notice.{" "}
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h3>9. Termination for Cause</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <p>
                                XAPPMEDIA shall have the right to terminate this Agreement in the event of any
                                material breach of this Agreement, or breach of any relevant terms of service, or
                                for its convenience. Prior notice and right to cure may or may not be given,
                                depending on the severity of the violation. For example, if Customer violates a law,
                                statute, or regulation, no prior notice or right to cure will be required.{" "}
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h3>10. Warranties</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <p>
                                XAPPMEDIA represents that it will provide the quality and quantity of services
                                specified in an applicable Service Order.{" "}
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h3>11. Disclaimer of Warranties</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <p>
                                EXCEPT AS SET FORTH HEREIN, XAPPMEDIA DISCLAIMS ALL REPRESENTATIONS OR WARRANTIES OF
                                ANY KIND, EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION THE IMPLIED WARRANTIES OF
                                MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE, OR THE WARRANTY OF
                                NONINFRINGEMENT.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h3>12. Limitations on Liability</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <p>
                                In no event shall either party be liable for any special, incidental or
                                extraordinary costs incurred by the party receiving the benefit of this paragraph,
                                or any consequential damages, or for interrupted communications, lost data or lost
                                profits, arising out of or in connection with this Agreement, nor shall any party’s
                                liability exceed the fees paid to XAPPMEDIA in the preceding twelve (12) calendar
                                months.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h3>13. Voice App Support</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <p>
                                Customer shall be responsible for updating Content through the web portal. For
                                support, please contact XAPPMEDIA customer support at:{" "}
                                <a href={`mailto:${__SUPPORT_EMAIL__}`}>{__SUPPORT_EMAIL__}</a>.
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h3>14. Assumptions</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <p>
                                a. Any changes to the nature, sequence or type of work may result in additional fees
                                or delayed delivery dates. In such instances, XAPPMEDIA will provide a reasonable
                                estimate/proposal as soon as practicable.
                            </p>
                            <p>
                                b. Delays caused by Customer may result in additional fees or delayed delivery
                                dates. In such instances, XAPPMEDIA will provide a reasonable estimate/proposal as
                                soon as practicable.
                            </p>
                            <p>
                                c. XAPPMEDIA will, at all times and in all instances, retain ownership of their
                                platform and may create similar products and similar products for other customers.
                            </p>
                            <p>
                                d. XAPPMEDIA and Customer each grant the other the right to market and promote the
                                skill and to describe to third parties the scope and nature the work performed to
                                create it.
                            </p>
                            <p>e. XAPPMEDIA may include Customer on XAPPMEDIA’s customer list.</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h3>15. Miscellaneous Provisions</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <p>
                                a. This Agreement will be governed by Delaware law without giving effect to
                                principles of conflict of laws. Both parties agree to submit to jurisdiction in
                                Delaware, and that any action brought regarding the enforcement or interpretation of
                                this Agreement shall be filed in the appropriate Delaware court. The prevailing
                                party in any action will be entitled to reasonable attorney's fees and costs.{" "}
                            </p>
                            <p>
                                b. If any provision of this Agreement is held to be unenforceable for any reason,
                                the remaining provisions shall remain in full force and effect.{" "}
                            </p>
                            <p>
                                c. The waiver of any breach of this Agreement will not operate as a waiver of any
                                other or subsequent breach.{" "}
                            </p>
                            <p>
                                d. This Agreement, including any Appendices thereto, constitutes the entire
                                understanding and agreement between XAPPMEDIA and Customer. This Agreement may only
                                be amended in writing, acknowledged by both parties.{" "}
                            </p>
                            <p>
                                e. The parties to this Agreement are independent contractors, and no agency,
                                partnership, joint venture, or employer / employee relationship is
                                intended or created. Neither party shall have the power to obligate or bind the
                                other.{" "}
                            </p>
                            <p>
                                f. Any notices required or permitted hereunder may be given by electronic mail or
                                fax if receipt is confirmed by the recipient, or if the notice is also sent by first
                                class mail. Notice will be deemed given on the date the electronic mail is sent.
                            </p>
                            <p>
                                g. The XAPPMEDIA portal may contain links to third-party sites that are unaffiliated
                                with XAPPMEDIA, and you follow or click on these links at your own risk.{" "}
                            </p>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <h3>Contact Us</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs>
                            <p>
                                If you have any questions about these Terms, please contact support at{" "}
                                <a href={`mailto:${__SUPPORT_EMAIL__}`}>{__SUPPORT_EMAIL__}</a>
                            </p>
                        </Col>
                    </Row>
                </Grid>
            </StandardLayout>
        </DocumentTitle>
    );
}

